/**
 * Crypto calculation utilities
 */

import { CryptoPrices } from '~/lib/api/repository';

/**
 * Calculate crypto amount from USD amount
 * @param usdAmount - Amount in USD
 * @param currency - Cryptocurrency (BTC, ETH, USDT, USDC)
 * @param prices - Price map from API
 * @returns Formatted crypto amount
 */
export function calculateCryptoAmount(
  usdAmount: string | number,
  currency: string,
  prices: CryptoPrices | Record<string, number> | undefined,
): string {
  if (!usdAmount || !currency || !prices) return '0';

  const amount =
    typeof usdAmount === 'string' ? parseFloat(usdAmount) : usdAmount;
  if (isNaN(amount) || amount <= 0) return '0';

  // Extract currency from wallet key (e.g., "BTC", "USDT_ERC20" -> "USDT")
  const cleanCurrency = currency.split('_')[0];
  const price = prices[cleanCurrency as keyof typeof prices];

  if (!price) return '0';

  return (amount / price).toFixed(8);
}

/**
 * Calculate credits from USD amount
 * $1 = 10 credits
 * @param usdAmount - Amount in USD
 * @returns Number of credits
 */
export function calculateCredits(usdAmount: string | number): number {
  const amount =
    typeof usdAmount === 'string' ? parseFloat(usdAmount) : usdAmount;
  if (isNaN(amount) || amount <= 0) return 0;
  return Math.floor(amount * 10); // $1 = 10 credits
}
